import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CardTagLine from './CardTagLine';
import DateTimeDisplay from './DateTimeDisplay';

export default class PerkCard extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    summary: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    value: PropTypes.string,
    image: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    company: PropTypes.string,
    company_url: PropTypes.string,
    is_favorited: PropTypes.bool.isRequired,
    votes_count: PropTypes.number,
    useTimezone: PropTypes.string,
    tags: PropTypes.array,
    collapsed: PropTypes.bool,
    maxTags: PropTypes.number,
  };

  static defaultProps = {
    votes_count: 0,
    company: null,
    company_url: null,
    collapsed: true,
    value: 0,
    tags: [],
    maxTags: 3,
    useTimezone: moment.tz.guess(),
  };

  constructor(props) {
    super(props);

    this.textAreaRef = null;
    this.state = {
      is_favorited: this.props.is_favorited,
      vote_count: this.props.votes_count,
      collapsed: this.props.collapsed,
    };
  }

  handleFavoriteClick = () => {
    $.ajax({
      url: this.props.toggle_favorite_url,
    });
    this.setState({
      is_favorited: !this.state.is_favorited,
      vote_count: this.state.is_favorited ? this.state.vote_count - 1 : this.state.vote_count + 1,
    });
  };

  handleCollapseToogle = () => {
    this.setState({ collapsed: !this.state.collapsed });
  };

  render() {
    const votesCounter = `${this.state.vote_count} Favorite${
      this.state.vote_count !== 1 ? 's' : ''
    }`;

    const imageStyle = {
      backgroundColor: '#fff',
      backgroundImage: `url(${this.props.image})`,
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
    };

    return (
      <div
        className={`Card-v2 Card-v2-padding ${this.props.featured ? 'Card-v2--featured' : ''}`}
        data-card-type={'Perk'}
        data-card-title={this.props.title}>
        <div className="u-flex u-flex-col">
          <div className="u-flex u-items-stretch">
            <div className="u-flex-none">
              <div
                className={`u-w-16 md:u-w-40 u-h-16 md:u-h-40 u-border u-rounded-sm ${
                  this.props.value && this.props.value > 0 ? 'u-rounded-b-none u--mb-px' : ''
                } ${this.props.featured ? 'u-border-yellow' : 'u-border-grey-light'}`}
                style={imageStyle}
              />
              {this.props.value && this.props.value > 0 && (
                <div
                  className={`u-text-white u-rounded-sm u-rounded-t-none u-w-full u-text-center u-py-0 md:u-py-1 u-text-sm ${
                    this.props.featured ? 'u-bg-orange' : 'u-bg-green'
                  }`}>
                  ${(+this.props.value).toFixed(0)}
                  <span className="u-hidden md:u-inline"> value</span>
                </div>
              )}
            </div>
            <div className="u-flex-1 u-flex u-flex-col u-pl-6">
              <div className="u-flex-1">
                {this.props.featured && (
                  <div className="u-float-right u-hidden md:u-block u-mb-2 u-ml-2">
                    <span className="u-pill u-pill--orange u-mr-0 u-mb-0">Featured perk</span>
                  </div>
                )}
                <h5 className="u-text-lg u-m-0 u-leading-none">
                  <a href={this.props.url}>{this.props.title}</a>
                </h5>
                {this.props.company && (
                  <div className="u-text-grey u-text-sm u-mt-1 u-leading-none">
                    Provided by <a href={this.props.company_url}>{this.props.company}</a>
                  </div>
                )}
                {this.state.collapsed && this.props.summary !== this.props.description && (
                  <div className="u-hidden md:u-block u-text-sm u-mt-2">
                    <div dangerouslySetInnerHTML={{ __html: this.props.summary }} />
                    <span
                      className="hover:u-underline u-cursor-pointer u-font-semibold u-text-old-primary-color-blue"
                      onClick={this.handleCollapseToogle}>
                      Read more
                    </span>
                  </div>
                )}
                {!this.state.collapsed && this.props.summary !== this.props.description && (
                  <div className="u-hidden md:u-block u-text-sm u-mt-2">
                    <div dangerouslySetInnerHTML={{ __html: this.props.description }} />
                    {this.props.collapsed && (
                      <span
                        className="hover:u-underline u-cursor-pointer u-font-semibold u-text-old-primary-color-blue"
                        onClick={this.handleCollapseToogle}>
                        Read less
                      </span>
                    )}
                  </div>
                )}
                {this.props.summary === this.props.description && (
                  <div
                    className="u-hidden md:u-block u-text-sm u-mt-2"
                    dangerouslySetInnerHTML={{ __html: this.props.description }}
                  />
                )}
              </div>
              <div className="u-flex-grow-0 u-hidden md:u-block">
                <a
                  href={this.props.url}
                  className="u-float-right Button Button--primary Button--small u-mb-0">
                  View Perk
                  <i className="Icon Icon-arrow-forward u-ml-1 u-mr-0" />
                </a>

                {this.props.tags.length > 0 && (
                  <CardTagLine
                    seeMoreURL={this.props.url}
                    tags={this.props.tags}
                    maxTags={this.props.maxTags}
                    keyIdentifier={this.props.title}
                  />
                )}
              </div>
            </div>
          </div>

          {/* Perk description */}
          {this.state.collapsed && this.props.summary !== this.props.description && (
            <div className="md:u-hidden u-text-base">
              <div dangerouslySetInnerHTML={{ __html: this.props.summary }} />
              <span
                className="hover:u-underline u-cursor-pointer u-text-sm u-font-semibold u-text-old-primary-color-blue"
                onClick={this.handleCollapseToogle}>
                Read more
              </span>
            </div>
          )}
          {!this.state.collapsed && this.props.summary !== this.props.description && (
            <div className="md:u-hidden u-text-base u-mt-2">
              <div dangerouslySetInnerHTML={{ __html: this.props.description }} />
              {this.props.collapsed && (
                <span
                  className="hover:u-underline u-cursor-pointer u-text-sm u-font-semibold u-text-old-primary-color-blue"
                  onClick={this.handleCollapseToogle}>
                  Read less
                </span>
              )}
            </div>
          )}
          {this.props.summary === this.props.description && (
            <div
              className="md:u-hidden u-text-base u-mt-2"
              dangerouslySetInnerHTML={{ __html: this.props.description }}
            />
          )}

          {this.props.tags.length > 0 && (
            <div className="md:u-hidden u-mt-2">
              <CardTagLine
                seeMoreURL={this.props.url}
                tags={this.props.tags}
                maxTags={2}
                keyIdentifier={this.props.title}
              />
            </div>
          )}
          <div className="md:u-hidden u-mt-4">
            <a href={this.props.url} className="u-w-full Button Button--primary">
              View Perk
              <i className="Icon Icon-arrow-forward u-ml-1 u-mr-0" />
            </a>
          </div>
        </div>
        <div className="u-flex u-items-center u-justify-between u-border-t u-border-grey-lighter u-mt-3 u-pt-2">
          <div>
            {!this.props.is_search_card && (
              <div className="u-flex">
                <div
                  className="u-text-old-primary-color-blue u-cursor-pointer u-flex u-items-center u-text-sm"
                  onClick={this.handleFavoriteClick}>
                  {this.state.is_favorited && (
                    <i className="Icon-favorite-full u-flex u-items-center u-mr-2" />
                  )}
                  {!this.state.is_favorited && (
                    <i className="Icon-favorite u-flex u-items-center u-mr-2" />
                  )}
                  <span className="u-font-semibold">Favorite</span>
                </div>
              </div>
            )}
          </div>
          <div className="u-flex u-justify-end u-items-center">
            <div className="u-flex u-items-center u-ml-2 u-text-grey u-font-semibold">
              <span className="u-text-sm">{votesCounter}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
